// src/api.js
import axios from 'axios';

const oapi = axios.create({

    // baseURL: 'http://localhost:5000/api', // Replace with your API URL
    baseURL: 'https://chat.cstmpanel.com/api', // Replace with your API URL
});

export default oapi;